import { AC_PAGE_MAX_INLINE_SIZE } from 'academy-navigation-lib/components/ACPage/ACPage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const LaerningContentInnerWrapper = ({
  children
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-default",
    paddingBlock: isMobile ? '500' : '500',
    paddingInline: isMobile ? '300' : undefined,
    children: /*#__PURE__*/_jsx(View, {
      marginInline: "auto",
      maxInlineSize: `${AC_PAGE_MAX_INLINE_SIZE}px`,
      children: children
    })
  });
};
export default LaerningContentInnerWrapper;